/* eslint-disable import/prefer-default-export */
import { orderBy } from 'lodash';
import { OrgChart, OrgChartUserId } from '../../types';
import { getActive } from './data';

export interface FormatColumns {
  size: number;
  report: OrgChartUserId;
  subreports: OrgChartUserId[];
}

function findSmallest(columns: Array<Array<FormatColumns>>) {
  const columnSizes = columns.map((column, idx) => {
    const total = column.map((c) => (c.size)).reduce((prev, current) => (prev + current), 0);
    return { idx, total };
  });

  const next = orderBy(columnSizes, ['total', 'idx'], ['asc', 'asc'])[0];

  return next.idx;
}

export function formatColumns(reports: string[], allUsers: OrgChart) {
  const columns: Array<Array<FormatColumns>> = [[], [], []];

  const mapping = reports.map((id) => {
    const current = getActive(id, allUsers);
    const size = (current.reports?.length || 0) + 1;

    return {
      size,
      report: current,
      subreports: current.reports.map((s) => getActive(s, allUsers)),
    };
  });

  const ordered = orderBy(mapping, ['size'], ['desc']);

  for (let i = 0; i < ordered.length; i += 1) {
    const idx = findSmallest(columns);
    columns[idx].push(ordered[i]);
  }

  return columns;
}
